import { useMutation } from '@tanstack/react-query';
import { type BatchProgress, confirmInBatches } from '../lib/bulk';
import type { ConfirmDecision } from '../lib/suggestion-types';
import { useInvalidateMapping } from './use-invalidate-mapping';

export type ConfirmVariables = {
  decisions: ConfirmDecision[];
  onProgress?: (progress: BatchProgress) => void;
};

/**
 * Links listings to products, 200 to a request, one request after another.
 * It settles with each row's outcome; a request that failed leaves its rows
 * (and the later ones) `not_sent` in the result. Lists refresh either way.
 */
export function useConfirmSuggestions() {
  const invalidate = useInvalidateMapping();

  return useMutation({
    mutationFn: ({ decisions, onProgress }: ConfirmVariables) =>
      confirmInBatches(decisions, onProgress),
    onSettled: invalidate,
  });
}
